export default __webpack_public_path__ + "static/media/black-text-logo.347e2620.svg";